const lightboxPillStyles = {
  ED: {
    default: { color: "white" },
    promotional: { color: "unset" },
  },
  OP: {
    default: { color: "white" },
  },
  GO: {
    default: { color: "white" },
  },
  TR: {
    default: { color: "white" },
    promotional: { color: "primary.90" },
  },
};

export default lightboxPillStyles;
